'use strict';

const build = require('./lib/builder.js');
const parse = require('./lib/parser.js');

module.exports.build = build;
module.exports.parse = parse;



//////////////////
// WEBPACK FOOTER
// ./~/vast-xml-4/index.js
// module id = 212
// module chunks = 0